'use strict';

DoohApps
    .factory('AppStoreData', ['restApi', function (restApi) {
        var controllerName = 'AppStore/';

        return {
            getAppList: function (successCallback, objectFilterOptions) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetAppStoreList', objectFilterOptions);
            },
            getAppById: function (successCallback, id) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetAppStoreById?appId=' + id);
            },
            getMarkets: function (successCallback) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetMarkets');
            },
            getInteractionTypes: function (successCallback) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetInteractionTypes');
            },
            getVendorApps: function (successCallback) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetVendorApps');
            },
            getAppUsage: function (successCallback, objectFilterOptions) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetAppUsage', objectFilterOptions);
            },
            getCampaignUsage: function (successCallback, filter) {
                restApi.PostApiMethod(successCallback, controllerName + 'GetCampaignUsage', filter);
            },
            requestServiceApp: function (successCallback, requestData) {
                restApi.PostApiMethod(successCallback, controllerName + 'RequestServiceApp', requestData);
            },
            getAppByUrlLink: function (successCallback, requestData) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetAppByUrlLink?urlLink=' + requestData);
            },
            getAppByID: function (successCallback, requestData) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetAppByID?appID=' + requestData);
            },
            hasUserUsedApp: function (successCallback, requestData) {
                restApi.GetApiMethod(successCallback, controllerName + 'HasUserUsedApp?appID=' + requestData);
            }
        }
    }])
    .factory('AppStoreDataFilter', function () {
        //Filter options to app store/////

        var DataFilter = {};

        DataFilter.SetDefault = function () {
            DataFilter.AppStoreFilter = {};
            DataFilter.AppStoreFilter.Offset = 0;
            DataFilter.AppStoreFilter.Count = 8;
            DataFilter.AppStoreFilter.Default = true;
            DataFilter.AppStoreFilter.Desc = false;
            DataFilter.AppStoreFilter.MostUse = false;
            DataFilter.AppStoreFilter.HighestRating = false;
            DataFilter.AppStoreFilter.Text = ''
            DataFilter.AppStoreFilter.PriceExpression = '0'
            DataFilter.AppStoreFilter.TotalCount = 0;
            DataFilter.AppStoreFilter.sentToInbox = 0;
            DataFilter.AppStoreFilter.MarketId = 0;
            DataFilter.AppStoreFilter.InteractionId = 0;
            DataFilter.AppStoreFilter.CompanyId = 0;
            DataFilter.AppStoreFilter.AppId = 0;
            DataFilter.AppStoreFilter.state = 6;
            DataFilter.AppStoreFilter.urlLink = '';
            DataFilter.SelectedApplication = {};
        };
        DataFilter.SetDefault();

        DataFilter.Clear = function () {
            DataFilter.SetDefault();
        }

        DataFilter.prepSelectedApplication = function (callback, that) {
            that.isSoon = (that.Status == 'Soon');
            that.isAdmin = (that.Status == 'AdminsOnly');
            that.isDevelopment = (that.Status == 'Development');
            DataFilter.SelectedApplication = that;
            callback(DataFilter.SelectedApplication);
        }

        return DataFilter;
    });
